import React from "react";

interface EventActionsProps {
  onEdit?: () => void;
  onDelete?: () => void;
  isLoading?: boolean; // Add isLoading prop
}

export const EventActions: React.FC<EventActionsProps> = ({
  onEdit,
  onDelete,
  isLoading = false, // Default to false if not provided
}) => (
  <div className="flex gap-2 mt-2">
    <button
      className="bg-blue-600 text-white px-2 py-1 rounded text-xs"
      onClick={onEdit}
      type="button"
    >
      Edit
    </button>
    <button
      className="bg-red-600 text-white px-2 py-1 rounded text-xs"
      onClick={onDelete}
      type="button"
      disabled={isLoading} // Disable the button while loading
    >
      {isLoading ? (
        <>
          <span className="animate-spin mr-2">⏳</span> Deleting...
        </>
      ) : (
        "Delete"
      )}
    </button>
  </div>
);